declare global {
  interface Window {
    ours?: {
      (
        command: "init",
        apiKey: string,
        config?: { track_web_events?: boolean },
      ): void;
      (command: "track", eventName: string, data?: Record<string, any>): void;
      queue: any[][];
      version: string;
    };
    ours_data?: Record<string, any>;
    oursLayer?: any[];
  }
}

export const OURS_EVENTS = {
  STATE_ENTRY: "State Entry",
  INSURANCE_ENTRY: "Insurance Entry",
  EMAIL_ENTRY: "Email Entry",
  APPOINTMENT_SLOT_SELECTION: "appointment_slot_selection",
} as const;

export const trackOursEvent = (
  name: string,
  data: Record<string, any> = {},
) => {
  if (window.ours) {
    window.ours("track", name, data);
  }
};
